import { styled } from 'goober';

export const List = styled('div')<{ $marginbottom?: number }>`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0px;
    flex-grow: 1;
    width: 100%;
    min-height: 0;
    margin-bottom: ${(props) => (props.$marginbottom ? `${props.$marginbottom}px` : '0px')};
`;

export const ListItem = styled('div')<{ $selected?: boolean; $header?: boolean }>`
    height: 32px;
    display: grid;
    padding: 0px 8px;
    border-bottom: ${(props) => (props.$header ? `1px solid ${props.theme.colors.neutral.w200}` : 'none')};
    border-radius: ${(props) => (props.$header ? 'none' : '8px')};
    align-items: center;
    justify-content: center;
    background-color: ${(props) => (props.$selected ? props.theme.colors.neutral.w100 : props.theme.colors.ui.white)};
    &:hover {
        background-color: ${(props) =>
            props.$header
                ? props.theme.colors.ui.white
                : props.$selected
                ? props.theme.colors.neutral.w100
                : props.theme.colors.neutral.w100};
    }
`;
